export interface CheckoutAbVariants {
  wallet?: "below"
  payment?: "card_only"
  layout?: "accordion_radios" | "accordion_no_radios"
  pricing?: "annual_only"
  express?: "always"
}

export type ExpressWalletPaymentMethodsMode = "auto" | "always"

export type PaymentElementLayoutKey = "tabs" | "accordion_radios" | "accordion_no_radios"

export function resolvePaymentElementLayout(
  layout?: CheckoutAbVariants["layout"]
): PaymentElementLayoutKey {
  if (layout === "accordion_radios" || layout === "accordion_no_radios") {
    return layout
  }
  return "tabs"
}

export function paymentElementLayoutOptions(layoutKey: PaymentElementLayoutKey) {
  switch (layoutKey) {
    case "accordion_radios":
      return {
        type: "accordion",
        defaultCollapsed: false,
        radios: "always",
      }
    case "accordion_no_radios":
      return {
        type: "accordion",
        defaultCollapsed: false,
        radios: "never",
        spacedAccordionItems: true,
      }
    default:
      return { type: "tabs" }
  }
}

export function expressCheckoutPlacementFromVariants(
  variants?: CheckoutAbVariants
): "above" | "below_cta" {
  return variants?.wallet === "below" ? "below_cta" : "above"
}

export function restrictToCardOnlyFromVariants(variants?: CheckoutAbVariants): boolean {
  return variants?.payment === "card_only"
}

export function annualOnlyPricingFromVariants(variants?: CheckoutAbVariants): boolean {
  return variants?.pricing === "annual_only"
}

export function expressWalletPaymentMethodsModeFromVariants(
  variants?: CheckoutAbVariants
): ExpressWalletPaymentMethodsMode {
  return variants?.express === "always" ? "always" : "auto"
}
